import { render, staticRenderFns } from "./MenuDetailsNew.vue?vue&type=template&id=30ff01ba&scoped=true&"
import script from "./MenuDetailsNew.vue?vue&type=script&lang=js&"
export * from "./MenuDetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./MenuDetailsNew.vue?vue&type=style&index=0&id=30ff01ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff01ba",
  null
  
)

export default component.exports